import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { AuthProvider } from './contexts/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import AdminRoute from './components/AdminRoute';
import RoleBasedRedirect from './components/RoleBasedRedirect';
import Login from './pages/Login';
import Stations from './pages/Stations';
import StationEditor from './pages/StationEditor';
import PartnerRegister from './pages/PartnerRegister';
import PrivacyPolicy from './pages/PrivacyPolicy';
import Support from './pages/Support';
import Landing from './pages/Landing';
import Users from './pages/admin/Users';
import AdminStations from './pages/admin/AdminStations';
import AdminClaims from './pages/admin/AdminClaims';
import AdminAnp from './pages/admin/AdminAnp';
import AdminOpportunities from './pages/admin/AdminOpportunities';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            {/* Rotas públicas */}
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/cadastro-parceiro" element={<PartnerRegister />} />
            <Route path="/politica-privacidade" element={<PrivacyPolicy />} />
            <Route path="/suporte" element={<Support />} />

            {/* Dono de posto: cadastro de postos e preços */}
            <Route
              path="/postos"
              element={
                <PrivateRoute>
                  <Stations />
                </PrivateRoute>
              }
            />
            <Route
              path="/postos/novo"
              element={
                <PrivateRoute>
                  <StationEditor />
                </PrivateRoute>
              }
            />
            <Route
              path="/postos/:id/editar"
              element={
                <PrivateRoute>
                  <StationEditor />
                </PrivateRoute>
              }
            />

            {/* Rotas de administração */}
            <Route
              path="/admin/postos"
              element={
                <AdminRoute>
                  <AdminStations />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/solicitacoes"
              element={
                <AdminRoute>
                  <AdminClaims />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/oportunidades"
              element={
                <AdminRoute>
                  <AdminOpportunities />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/anp"
              element={
                <AdminRoute>
                  <AdminAnp />
                </AdminRoute>
              }
            />
            <Route
              path="/admin/usuarios"
              element={
                <AdminRoute>
                  <Users />
                </AdminRoute>
              }
            />

            {/* Redirecionamentos */}
            <Route path="*" element={<RoleBasedRedirect />} />
          </Routes>

          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
